<template>
    <div>
       <SuperKidPublicHeader></SuperKidPublicHeader>
        <div class="container">
            <div class="every-child-shines">
                <h3>Where Every Child Shines</h3>
                <h6 class="col-md-6 m-auto">Celebrate your child’s talent, confidence, culture, and creativity in Nigeria’s biggest kids empowerment movement.</h6>

                <button class="btn register-btn mt-5" @click="routeTo('/dashboard/superkid-register')">Register Now</button>
            </div>

            <div class="kids-pictures scrollable-element">
                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765666/Frame_1707482356_fvmu5d.png" alt="">
                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765667/Frame_1707482357_q3wj8u.png" alt="">
                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765667/Frame_1707482358_jv7o3w.png" alt="">
                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765668/Frame_1707482359_byz1ya.png" alt="">
                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765558/Frame_1707482360_yc4udg.png" alt="">
            </div>

            <div class="deserve-shine">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div>
                            <h3>Your Child Deserves to Shine</h3>
                            <p>Imagine your child's face lighting up when they receive their first SuperKids badge or certificate. Picture yourself proudly sharing their achievement with family and friends. Think about the moment they stand on a global stage, beaming with confidence.</p>
                            <p>This isn't just another children's program. This is SuperKids, where the star in every child shines bright and parents become their biggest cheerleaders.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="w-100" src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773765726/portrait-daughter-father-using-digital-tablet-while-staying-home_1_kamwb4.png" alt="">
                    </div>
                </div>
            </div>

            <div class="how-kid-join-holder">
                <div class="how-kid-join-text">
                    <div class="row">
                        <div class="col-md-6">
                            <h3>How Your Child Joins the Movement</h3>
                        </div>
                        <div class="col-md-6">
                            <h6>SuperKids helps every child shine. In a few steps, they can express talents, earn recognition, and contribute to community change.</h6>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">

                        <div class="htj-item ol">
                            <p>1</p>
                            <div>
                                <h4>Register Your Child (Ages 6-12)</h4>
                                <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">

                        <div class="htj-item bl">
                            <p>2</p>
                            <div>
                                <h4>Weekly Fun Challenges Begins</h4>
                                <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="htj-item yl">
                            <p>3</p>
                            <div>
                                <h4>Instant Recognition</h4>
                                <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="htj-item dol">
                            <p>4</p>
                            <div>
                                <h4>Earn Real Rewards as a Parent</h4>
                                <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="htj-item pl">
                            <p>5</p>
                            <div>
                                <h4>Create Community Impact</h4>
                                <h6 class="col-md-6 pl-0">Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="weekly-fun-challenge-holder container">
                <div class="how-kid-join-text" style="margin-top: 7rem;">
                    <div class="row">
                        <div class="col-md-6">
                            <h3 style="font-size: 41px;">Weekly Fun Challenges</h3>
                        </div>
                        <div class="col-md-6">
                            <h6>Every week brings new opportunities for <br> your child to shine.</h6>
                        </div>
                    </div>
                </div>
                <div >
                    <div class="row"> 
                        <div class="weekly-card-holder scrollable-element" ref="scrollContainer">
                            <div class="weekly-card atat">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Art Attack</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card mtog">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Super Speeches</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card stem">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Stem Explorers</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card ability">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Dance</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card super-speech">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Music</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card music">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Mother Tongue</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card dance">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>Foreign Languages</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                            <div class="weekly-card flang">
                                <img src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773921111/Frame_1707482244_cutmg0.png" alt="">
                                <div>
                                    <h4>The Abilities Challenge</h4>
                                    <h6>Watch your child build confidence as they deliver speeches on topics they care about. From "My Hero" to "My Dream for Nigeria," they learn to express themselves boldly.</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mt-5 mb-5">
                        <button @click="scroll('left')" class="arrow-indicator btn"><i class="fa fa-arrow-left"></i></button>
                        <button @click="scroll('right')" class="arrow-indicator btn"><i class="fa fa-arrow-right"></i></button>
                    </div>
                </div>
            </div>

            <div class="why-sk-special container">
                <div class="how-kid-join-text" style="margin-top: 7rem;">
                    <div class="row mb-5">
                        <div class="col-md-6">
                            <h3 >Why Superkid is Special</h3>
                        </div>
                        <div class="col-md-6">
                            <h6>SuperKids helps every child shine. In a few steps, they can express talents, earn recognition, and contribute to community change.</h6>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8">
                            <div class="htj-item ol">
                                <p>1</p>
                                <div>
                                    <h4>Weekly Fun Challenges Begin</h4>
                                    <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                                </div>
                            </div>
                            <div class="htj-item ppl">
                                <p>2</p>
                                <div>
                                    <h4>Weekly Fun Challenges Begin</h4>
                                    <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                                </div>
                            </div>
                            <div class="htj-item lpl">
                                <p>3</p>
                                <div>
                                    <h4>Weekly Fun Challenges Begin</h4>
                                    <h6>Parents, schools and orphanages can register in seconds. Visit myshelta.com or download the mobile app to register your child in seconds.</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div>
                                <img class="w-100" src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1773940282/Frame_1707482374_xyznle.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="bottom-down-bg">
                    <h2>Every Child Has a Super Ability</h2>
                    <h5 class="col-md-6">Imagine your child's face lighting up when they receive their first SuperKids badge or certificate. Picture yourself proudly sharing their achievement with family and friends. Think about the moment they stand on a global stage, beaming with confidence.</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SuperKidPublicHeader from "./SuperKidPublicHeader.vue";
export default {
  name: "SuperkidLanding",
  components: {
    SuperKidPublicHeader
  },
  data() {
    return {
      email: JSON.parse(localStorage.getItem("shelta-user")).email,
      isOpen: false
    };
  },
  watch: {
        $route() {
            this.isOpen = false;
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
        // Important: Clean up to avoid memory leaks
        window.removeEventListener('keydown', this.handleKeyDown);
    },
  //  mounted() {
  //    this.email = JSON.parse(localStorage.getItem("shelta-user")).email
  //    console.log("Email", this.email);
  //  }
  methods: {
    routeTo(route) {
        this.$router
        .push({
            path: route
            })
            .catch(() => {
            // console.log("none")
        });
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    scroll(direction) {
      const container = this.$refs.scrollContainer;
      // Scrolls by the visible width of the container
      const distance = container.clientWidth; 

      if (direction === 'left') {
        container.scrollBy({ left: -distance, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: distance, behavior: 'smooth' });
      }
    },
    handleKeyDown(e) {
      if (e.key === 'ArrowRight') this.scroll('right');
      if (e.key === 'ArrowLeft') this.scroll('left');
    }
  }
};
</script>


<style lang="scss" scoped>


.every-child-shines {
    margin-top: 40px;
    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 52px;
        line-height: 60px;
        color: #1C2B3A;
        text-align: center;
        margin-bottom: 25px;

    }
    h6 {
        font-family: Nunito;
        font-weight: 600;
        font-size: 20px;
        line-height: 37px;
        color: #5D6F7C;
        text-align: center;

    }
    .register-btn {
        font-family: Lato;
        font-weight: 600;
        min-height: 50px;
        font-size: 18px;
        color: #ffffff;
        background: #2EBFCA;
        border-radius: 50px;
        width: 164px;

    }
}

.kids-pictures {
    margin-top: 80px;
    margin-top: 40px;
    display: flex;
    overflow-x: scroll;
    img:not(:last-child) {
        margin-right: 15px;
    }

}

.deserve-shine {
    margin-top: 10rem;
    align-items: center;
    h3  {
        font-family: Poppins;
        color: #1C2B3A;
        font-size: 52px;
        line-height: 70px;
        text-align: left;

    }
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 20px;
        text-align: left;
        line-height: 36px;
        color: #5D6F7C;

    }
}

// .how-kid-join-holder {
//     margin-top: 15rem;
// }
.how-kid-join-text {
    margin-top: 15rem;
    margin-bottom: 3rem;
    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 45px;
        color: #1C2B3A;
        text-align: left;
        line-height: 65px;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        color: #5D6F7C;
        text-align: right;

    }
}

.htj-item {
    border-radius: 8px;
    padding: 32px;
    margin-bottom: 20px;
    p {
        font-family: Lato;
        font-weight: 700;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        margin-bottom: 0;

    }
    h4 {
        margin-top: 15px;
        font-family: Lato;
        font-weight: 700;
        font-size: 32px;
        line-height: 32px;
        color: #1C2B3A;
        text-align: left;
    }
    h6 {
        font-family: Nunito;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #5D6F7C;
        text-align: left;
    }
}
.ol {
    border: 1px solid #F8805D;
    p { background-color: #F8805D; }
}
.bl {
    border: 1px solid #325476;
    p { background-color: #325476; }
}
.yl {
    border: 1px solid #FADC00;
    p { background-color: #FADC00; }
}

.dol {
    border: 1px solid #cc6745;
    p { background-color: #cc6745; }
}


.pl {
    border: 1px solid #7E65BD;
    p { background-color: #7E65BD; }
}

.lpl {
    border: 1px solid #EC2A90;
    p { background-color: #EC2A90; }
}

.ppl {
    border: 1px solid #7E65BD;
    p { background-color: #7E65BD; }
}

.weekly-card {
    img {
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
    }
    h4 {
        font-family: Lato;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        color: #000000;
        text-align: left;
    } h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        line-height: 30px;
        color: #000000;
        text-align: left;

    }
}

.weekly-card-holder {
    flex-wrap: nowrap;
    margin-top: 4rem;
    overflow-x: scroll;
    display: flex;
}

.weekly-card {
    div {
        padding: 15px;
    }
}

.weekly-card:not(:last-child) {
    margin-right: 30px;
}
.atat {
    background-color: #2AB3E64D;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}   
.mtog {
    background-color: #A447C24D;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.stem {
    background-color: #00C8B34D;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.ability {
    background-color: #FADC00;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.super-speech {
    background-color: #EC2A90;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.music {
    background-color: #F8805D;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.dance {
    background-color: #7E65BD;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}
.flang {
    background-color: #bf3203;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.arrow-indicator {
    border: none;
    background: transparent;
}
.arrow-indicator {
    box-shadow: none;
    outline: 0;
   i::before {
    font-size: 30px;
   }
}
.bottom-down-bg {
    background-image: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 40.04%), url("https://res.cloudinary.com/dr2wljdlc/image/upload/v1773943273/bg-bootom_raiddp.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 450px;
    height: 100%;
    border-radius: 10px;
    margin-bottom: 4rem;
    padding: 5rem 20px;
    h2 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 34px;
        line-height: 44px;
        color: #ffffff;
        text-align: left;
        margin-bottom: 30px;

    }
    h5 {
        font-family: Nunito;
        font-weight: 600;
        font-size: 20px;
        line-height: 34px;
        color: #ffffff;
        text-align: left;
        padding: 0;
    }
}
@media (max-width: 768px) {
    .every-child-shines {
        h3 {
            font-size: 41px;
            // line-height: ;
        }
    }
    .deserve-shine {
        margin-top: 4rem;
        h3 {
            font-size: 40px;
            line-height: 58px;
        }
    }
    .weekly-card-holder {
        margin-top: 0rem;
    }
    .how-kid-join-text {
        margin-top: 6rem;
        h3 {
            font-size: 38px;
            line-height: 51px;
        }
        h6 {
            text-align: left;
        }
    }
    .htj-item {
        padding: 32px 15px;
        h4 {
            font-size: 27px;
            line-height: 38px;
        }
        p {
            width: 30px;
            height: 30px;
            font-size: 19px;
        }
    }
    .arrow-indicator {
        i::before {
            font-size: 24px;
        }
    }
}



.scrollable-element {
  -ms-overflow-style: none;  /* Internet Explorer and Edge */
  scrollbar-width: none;     /* Firefox */
  overflow-y: scroll;        /* Optional: ensures scrolling is possible if content overflows vertically */
}

.scrollable-element::-webkit-scrollbar {
  display: none;             /* Chrome, Safari, Opera, older Edge */
  width: 0;                  /* Optional: for a cleaner hide */
  height: 0;                 /* Optional: for horizontal scrollbar hide */
}
</style>